/*
 * Copyright (C) 2025 Netgem SA
 *
 * This software is the copyrighted work of Netgem and constitutes
 * confidential information.
 *
 * By using this software you agree to hold the Confidential Information in
 * strict confidence and shall not disclose such information to any third party
 * without the written permission of Netgem SA. You also agree to employ all
 * steps necessary to protect the Confidential Information from unauthorized
 * disclosure or use, including without limitation, all steps you use to protect
 * information considered proprietary and a trade secret.
 */

import {
    getBaseUrl,
    getExternalBaseUrl,
    getVivaBaseUrl,
} from '@services/endpoints';

const baseUrl = getBaseUrl();
const vivaBaseUrl = getVivaBaseUrl();

export const apiPaths = {
    baseUrl: () => `${baseUrl}/api`,
    vivaBaseUrl: () => `${vivaBaseUrl}/api`,
    // vivaBaseUrl: () => `${vivaBaseUrl}/tmdb`,

    authentication: {
        // login: () => '/authentication/login',
        // logout: () => '/authentication/logout',
        login: () => 'j_spring_security_check',
        logout: () => 'j_spring_security_logout',
        /* TODO: Check for retrieving token 
            https://platform.limecraft.com/api/authentication/user/suprsendsignedtoken
        */
    },

    productions: {
        getAvatar: (id: string) => `/production/${id}/avatar`,
    },

    data: {
        getAccounts: (userId: string) => `/user/${userId}/accountrights`,
        getProductions: () => `/production`,
        getUserData: () => `/authentication/user`,
        getCollections: (productionId: string) =>
            `/production/${productionId}/eo`,
        getClips: (productionId: string) =>
            `/production/${productionId}/an/search`,
        getClip: (productionId: string, assetId: string) =>
            `/production/${productionId}/an/${assetId}`,
        getWorkflow: (productionId: string) =>
            `/production/${productionId}/workflow/search`,
    },

    metadata: {
        getCollectionMetadata: (proscopeId: string) =>
            `/mamutils/metadata/${proscopeId}`,
        getOverrideHistory: (proscopeId: string) =>
            `/mamutils//overrides/${proscopeId}`,
        saveOverride: (proscopeId: string) =>
            `/mamutils//overrides/${proscopeId}`,
    },

    customFieldDescription: {
        annotation: (productionId: string) => `/production/${productionId}/cfd`,
        editorialObject: (productionId: string) =>
            `/production/${productionId}/eocfd`,
    },

    media: {
        getMoi: (productionId: string, mediaObjectId: string, moiId: string) =>
            `/production/${productionId}/mo/${mediaObjectId}/moi/${moiId}`,
        getTracks: (
            productionId: string,
            mediaObjectId: string,
            moiId: string,
        ) =>
            `/production/${productionId}/mo/${mediaObjectId}/moi/${moiId}/track`,
    },

    share: {
        createEo: (productionId: string) => `/production/${productionId}/eo`,
        attach: (productionId: string, eoId: string) =>
            `/production/${productionId}/eo/${eoId}/attach`,
        shareEo: (productionId: string, eoId: string) =>
            `/production/${productionId}/eo/${eoId}/share`,
        deleteEo: (productionId: string, eoId: string) =>
            `/production/${productionId}/eo/${eoId}?deleteAssemble=true`,
        addSharedUser: (productionId: string, shareId: string) =>
            `/production/${productionId}/share/${shareId}/shareduser`,
        notifySharedUser: (
            productionId: string,
            shareId: string,
            sharedUserId: string,
        ) =>
            `/production/${productionId}/share/${shareId}/shareduser/${sharedUserId}/notify`,
        generatePublicLink: (productionId: string, token: string) =>
            `${getExternalBaseUrl()}/#shared/production/${productionId}/${token}`,
    },

    send: {
        carrickFlow: () => `/carrickflow/public/workflows`,
        // 'https://apiws.carrick-skills.com:8443/carrickflow/public/workflows',
    },
};

/**
 * No need to handle the token ourself,
 * the backend is already configured for a
 * session-based authentication using
 * HttpOnly and Secure cookies
 * (MOJITO_SESSION_ID_V2; Secure)
 */
export const setHeaders = (headers: Headers) => {
    headers.set('content-type', 'application/json');
    return headers;
};
